export default __webpack_public_path__ + "static/media/pin-new-theme.8558cd36.svg";